import { Outlet } from "react-router-dom";
import { IndexPageHeaderWithCollect } from "./IndexPageHeaderWithCollect";
import { memo } from "react";

interface DefaultIndexWithCollectProps {
  title: string;
  query: Function;
  collectMutation: Function;
  collector: (collectCallback: (data: any) => Promise<any>) => JSX.Element;
  generalInfoPresentor?: (info: any) => JSX.Element | null;
}

const DefaultIndexWithCollect = memo(({ title, query, collectMutation, collector, generalInfoPresentor }: DefaultIndexWithCollectProps) => {
  return (
    <div>
      <IndexPageHeaderWithCollect
        title={title}
        query={query}
        collectMutation={collectMutation}
        collector={collector}
        generalInfoPresentor={generalInfoPresentor}
      />
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
});

export const GetDefaultIndexWithCollect =
  ({ title, query, collectMutation, collector, generalInfoPresentor }: DefaultIndexWithCollectProps) =>
  () =>
    (
      <DefaultIndexWithCollect
        title={title}
        query={query}
        collectMutation={collectMutation}
        collector={collector}
        generalInfoPresentor={generalInfoPresentor}
      />
    );
